import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SessionOidcService } from 'app/services/external/auth-oidc/session-oidc.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AmsAuthInterceptor implements HttpInterceptor {
  private readonly _sessionOidcService = inject(SessionOidcService);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.requestNeedsToken(req)) {
      return next.handle(req);
    }
    return next.handle(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${this._sessionOidcService.currentSession().accessToken}`
        }
      })
    );
  }

  private requestNeedsToken(request: HttpRequest<unknown>): boolean {
    return !(
      request.url.includes('/assets') ||
      request.url.includes('/openid-configuration') ||
      request.url.includes('/connect')
    );
  }
}
